import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './app/Main.jsx';
import './root.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Main />);
